import { ApiService }     from '../../app-lite/api/api.service';
import { SessionService } from '../../app-lite/sessions/session.service';

import QuickbooksExportHtml   from './quickbooks.export.html';
import QuickbooksSettingsHtml from './quickbooks.settings.html';

export function QuickbooksStates (
   $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'ExportQBCtrl',
    name       : 'app.quickbooks-export',
    templateUrl: QuickbooksExportHtml,
    url        : '/quickbooks_export',
    resolve    : {
      types   : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/quickbooks/available_types'),
      settings: ( sessionObjAPI : SessionService, workshopAPI : ApiService ) : ng.IPromise<any> =>
        sessionObjAPI
          .refresh()
          .then(() => workshopAPI.get('/quickbooks/defaults'))
    }
  }).state({
    controller : 'QuickbooksSettingsCtrl',
    name       : 'app.quickbooks-settings',
    templateUrl: QuickbooksSettingsHtml,
    url        : '/quickbooks_settings',
    resolve    : {
      accountingSettings: ( $rootScope : any ) : ng.IPromise<any> => $rootScope.Company.getAccountingSettings(),
      session           : ( sessionObjAPI : SessionService ) : ng.IPromise<any> => sessionObjAPI.refresh(),
      settings          : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company')
    }
  });
}